/** @jsx jsx */
import { jsx } from "@emotion/core"

type FlexProps = {
  gap?: number
  direction?: "row" | "column" | "row-reverse" | "column-reverse"
  wrap?: "nowrap" | "wrap" | "wrap-reverse" | boolean
  alignItems?: "stretch" | "center" | "baseline" | "start" | "end"
  justifyContent?: "start" | "end" | "center" | "space-between" | "space-around" | "space-evenly"
} & React.HTMLAttributes<HTMLDivElement>

export function Flex({ gap, direction, wrap, alignItems, justifyContent, ...rest }: FlexProps) {
  return (
    <div
      css={{
        display: "flex",
        gap,
        flexDirection: direction,
        flexWrap: typeof wrap === "boolean" ? (wrap ? "wrap" : "nowrap") : wrap,
        alignItems,
        justifyContent,
      }}
      {...rest}
    />
  )
}

Flex.Spacer = () => <div css={{ flex: 1 }} />
